export interface StatusBadge {
  label: string
  classes: string
}

/** True when silence_pending_termination_until is a future date (employee is muted). */
export function isEmployeeMuted (silencePendingTerminationUntil: string | null): boolean {
  if (!silencePendingTerminationUntil) return false
  const today = new Date().toISOString().slice(0, 10)
  const muteUntilDate = silencePendingTerminationUntil.slice(0, 10)
  return muteUntilDate > today
}

/**
 * Determines status badge styling based on employment status and mute.
 * Priority: Muted (gray) > Payroll deactivated (orange) > Active (green).
 */
export function getEmployeeStatusBadge (
  status: string,
  _endDate: string | null,
  silencePendingTerminationUntil: string | null
): StatusBadge {
  const today = new Date().toISOString().slice(0, 10)

  const muteUntilDate = silencePendingTerminationUntil?.slice(0, 10)
  if (muteUntilDate && muteUntilDate > today) {
    return {
      label: 'On leave',
      classes: 'bg-gray-100 text-gray-500',
    }
  }

  if (status === 'pending_deactivation') {
    return {
      label: 'Payroll deactivated',
      classes: 'bg-orange-100 text-orange-700',
    }
  }

  return {
    label: 'Active',
    classes: 'bg-green-100 text-green-700',
  }
}
